import React, { useState } from 'react';
import { LegalModal, LegalDocType } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDocType | null>(null);
  return <footer className="bg-cream border-t border-ink/5 pt-14 md:pt-16 pb-10" data-id="element-69">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col items-center" data-id="element-70">
        {/* Legal links — contained in a small bordered box */}
        <div className="inline-flex items-center border border-ink/15 rounded-md divide-x divide-ink/10 mb-8 md:mb-10" data-id="element-71">
          <button onClick={() => setOpenDoc('privacy')} className="px-4 py-2 text-[11px] uppercase tracking-widest text-ink-light hover:text-ink transition-colors" data-id="element-72">
            Política de Privacidad
          </button>
          <button onClick={() => setOpenDoc('terms')} className="px-4 py-2 text-[11px] uppercase tracking-widest text-ink-light hover:text-ink transition-colors" data-id="element-73">
            Términos de Servicio
          </button>
        </div>

        <p className="text-xs text-ink-light/50" data-id="element-74">
          © {new Date().getFullYear()} El Cambio Hormonal. Todos los derechos
          reservados.
        </p>
        <p className="text-sm text-ink-light/60 mt-4 max-w-xl text-center italic font-serif" data-id="element-75">
          Creado con amor para acompañar a la mujer moderna en su camino hacia
          el balance natural.
        </p>
      </div>

      <LegalModal open={openDoc !== null} doc={openDoc ?? 'privacy'} onClose={() => setOpenDoc(null)} data-id="element-76" />
    </footer>;
}